// NEON — script propio de la línea "Máscara LED Neón Purge" (Halloween).
// Independiente de mt-scripts.js a propósito: esta página no debe depender
// de ni tocar el script de la otra línea de producto.
document.addEventListener('DOMContentLoaded', function () {
  initNeonReveal();
  initNeonGaleria();
  initNeonVariantes();
  initNeonStickyBar();
  initNeonCuentaAtras();
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) initNeonCuentaAtras();
});

function initNeonReveal() {
  var els = document.querySelectorAll('.neon-reveal');
  if (!els.length) return;
  function mostrarTodo() { els.forEach(function (el) { el.classList.add('neon-visible'); }); }
  if (!('IntersectionObserver' in window)) { mostrarTodo(); return; }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('neon-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
  setTimeout(mostrarTodo, 2500);
}

function initNeonGaleria() {
  // NEON — arreglo de bug real: antes esta función tenía su PROPIA
  // lógica para cambiar solo la imagen principal, separada de la
  // lógica real de selección de variante (círculos de color, precio,
  // campo oculto de variante para el carrito). Resultado: tocar una
  // miniatura cambiaba la foto pero podía dejar seleccionado — y
  // añadido al carrito — un color distinto al que se veía en pantalla.
  // Ahora cada miniatura representa un color real (ver
  // sections/neon-producto.liquid, una miniatura por variante) y, en
  // vez de duplicar la lógica, simplemente reenvía el clic al círculo
  // de color equivalente (.neon-prod-swatch), que ya hace todo lo
  // demás — una sola fuente de verdad para "qué color está elegido".
  var minis = document.querySelectorAll('.neon-prod-mini');
  if (!minis.length) return;
  minis.forEach(function (btn) {
    btn.addEventListener('click', function () {
      minis.forEach(function (m) { m.classList.remove('neon-activa'); });
      btn.classList.add('neon-activa');
      var valor = btn.getAttribute('data-value');
      if (!valor) return;
      // NEON: con selección múltiple de colores, reenviar el clic al círculo
      // ALTERNARÍA (des-marcaría el color si ya estaba elegido). Se usa la
      // función que expone initNeonVariantes ("elegir este color y verlo");
      // si no existe (producto sin selección múltiple), se mantiene el
      // comportamiento de siempre.
      if (typeof window.neonElegirColor === 'function') { window.neonElegirColor(valor); return; }
      var swatch = document.querySelector('.neon-prod-swatch[data-value="' + CSS.escape(valor) + '"]');
      if (swatch) swatch.click();
    });
  });
}

function initNeonVariantes() {
  var form = document.getElementById('neon-form-producto');
  var data = document.getElementById('neon-prod-variantes');
  if (!form || !data) return;
  var variantes;
  try { variantes = JSON.parse(data.textContent); } catch (e) { return; }
  if (!variantes.length) return;

  var grupos = document.querySelectorAll('.neon-prod-opcion-valores');
  var idInput = document.getElementById('neon-prod-variant-id');
  var precioEl = document.getElementById('neon-prod-precio');
  var precioTachadoEl = document.getElementById('neon-prod-precio-tachado');
  var descuentoBadgeEl = document.getElementById('neon-prod-descuento-badge');
  var addBtn = document.getElementById('neon-prod-add');
  var addTexto = document.getElementById('neon-prod-add-texto');
  var principal = document.getElementById('neon-prod-imagen-principal');
  var textoAgotado = addBtn ? addBtn.getAttribute('data-texto-agotado') : null;
  var stickyPrecioEl = document.getElementById('neon-prod-sticky-precio');
  var stickyBtn = document.getElementById('neon-prod-sticky-btn');
  var stickyTexto = document.getElementById('neon-prod-sticky-btn-texto');
  var stickyTextoAgotado = stickyBtn ? stickyBtn.getAttribute('data-texto-agotado') : null;

  // NEON (oct 2026) — selección MÚLTIPLE de color: solo cuando el producto
  // tiene exactamente UNA opción (el color). "elegidos" guarda los colores
  // marcados, en orden de toque, cada uno con su cantidad; el último es el
  // "principal" (el que se ve en foto/precio y el que usa el botón de pago
  // exprés, que solo admite una variante). Con más opciones (talla, etc.)
  // la selección múltiple sería ambigua: se mantiene el modo de siempre.
  var multi = grupos.length === 1 && grupos[0].querySelectorAll('.neon-prod-swatch').length > 1;
  var elegidos = [];
  var seleccionEl = document.getElementById('neon-prod-seleccion');
  var notaMultiEl = document.getElementById('neon-prod-multi-nota');
  var pagoEl = document.querySelector('.neon-prod-pago-dinamico');
  var errorEl = document.getElementById('neon-prod-error');
  var cantFilaEl = document.querySelector('.neon-prod-cantidad');
  if (multi) {
    var activoInicial = grupos[0].querySelector('.neon-prod-swatch.neon-activa') || grupos[0].querySelector('.neon-prod-swatch');
    elegidos.push({ valor: activoInicial.getAttribute('data-value'), cant: 1 });
    if (cantFilaEl) cantFilaEl.style.display = 'none';
  }
  function varianteDeColor(valor) {
    return variantes.find(function (v) { return v.options[0] === valor; });
  }
  function principalMulti() { return elegidos[elegidos.length - 1]; }

  function seleccionActual() {
    if (multi) return [principalMulti().valor];
    var sel = [];
    grupos.forEach(function (g) {
      var activo = g.querySelector('.neon-prod-swatch.neon-activa');
      sel.push(activo ? activo.getAttribute('data-value') : null);
    });
    return sel;
  }

  function encontrarVariante() {
    var sel = seleccionActual();
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return sel[i] === null || opt === sel[i]; });
    });
  }

  function actualizar() {
    var v = encontrarVariante();
    if (!v) return;
    idInput.value = v.id;
    if (precioEl) precioEl.textContent = v.price;
    if (precioTachadoEl) {
      if (v.compare_at_price && v.compare_at_price !== v.price) {
        precioTachadoEl.textContent = v.compare_at_price;
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (descuentoBadgeEl) {
      // NEON (oct 2026) — mismo criterio que precioTachadoEl de arriba:
      // solo se muestra con descuento real. Usa price_num/compare_at_price_num
      // (números crudos, ver comentario en neon-producto.liquid) en vez de
      // parsear el texto formateado con símbolo de moneda.
      if (v.compare_at_price_num && v.compare_at_price_num > v.price_num) {
        var pct = Math.round((v.compare_at_price_num - v.price_num) / v.compare_at_price_num * 100);
        descuentoBadgeEl.textContent = '-' + pct + '%';
        descuentoBadgeEl.style.display = '';
      } else {
        descuentoBadgeEl.style.display = 'none';
      }
    }
    if (addBtn) {
      addBtn.disabled = !v.available;
      if (addTexto) addTexto.textContent = v.available ? (addTexto.getAttribute('data-disponible') || addTexto.textContent) : (textoAgotado || addTexto.textContent);
    }
    // NEON: la imagen principal lleva srcset (ver neon-producto.liquid) y con
    // srcset el navegador IGNORA "src" — cambiar solo src dejaba la foto del
    // primer color. Se reescriben también srcset (las 3 anchuras del color
    // elegido) y src, para que la foto cambie y siga siendo responsive.
    if (principal && v.featured_image) {
      if (v.img_srcset) principal.srcset = v.img_srcset;
      else principal.removeAttribute('srcset');
      principal.src = v.featured_image;
    }
    if (stickyPrecioEl) stickyPrecioEl.textContent = v.price;
    if (stickyBtn) {
      stickyBtn.disabled = !v.available;
      if (stickyTexto && addTexto) stickyTexto.textContent = v.available ? (addTexto.getAttribute('data-disponible') || addTexto.textContent) : (stickyTextoAgotado || addTexto.textContent);
    }
    // Refleja el nombre del valor elegido junto a la etiqueta de la opción
    grupos.forEach(function (g, i) {
      var wrap = g.closest('.neon-prod-opcion');
      var etiqueta = wrap ? wrap.querySelector('[data-neon-opcion-actual]') : null;
      var activo = g.querySelector('.neon-prod-swatch.neon-activa');
      if (etiqueta && multi) etiqueta.textContent = elegidos.map(function (e) { return e.valor; }).join(', ');
      else if (etiqueta && activo) etiqueta.textContent = activo.getAttribute('data-value');
    });
    if (multi) pintarSeleccion();
    // NEON: sincroniza también las miniaturas de foto con el color
    // realmente activo — así da igual si el cliente cambia el color
    // desde el círculo o desde la miniatura, todo queda coherente
    // (mismo criterio que arregla initNeonGaleria más arriba).
    var neonValorActivo = seleccionActual()[0];
    if (neonValorActivo) {
      document.querySelectorAll('.neon-prod-mini').forEach(function (m) {
        m.classList.toggle('neon-activa', m.getAttribute('data-value') === neonValorActivo);
      });
    }
  }

  var cantidadInput = document.getElementById('neon-prod-cantidad');
  var swatchesTodos = document.querySelectorAll('.neon-prod-swatch');

  function mostrarError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  function sincronizarCampos() {
    // Campos ocultos del formulario nativo: los lee el botón de pago exprés
    // (solo admite UNA variante — la principal — y su cantidad).
    var p = principalMulti();
    var v = varianteDeColor(p.valor);
    if (v) idInput.value = v.id;
    if (cantidadInput) cantidadInput.value = p.cant;
  }

  function marcarSwatches() {
    swatchesTodos.forEach(function (b) {
      var activo = elegidos.some(function (e) { return e.valor === b.getAttribute('data-value'); });
      b.classList.toggle('neon-activa', activo);
      b.setAttribute('aria-pressed', activo ? 'true' : 'false');
    });
  }

  function pintarSeleccion() {
    if (!seleccionEl) return;
    seleccionEl.hidden = false;
    seleccionEl.innerHTML = '';
    elegidos.forEach(function (e) {
      var sw = grupos[0].querySelector('.neon-prod-swatch[data-value="' + CSS.escape(e.valor) + '"] .neon-prod-swatch-color');
      var fila = document.createElement('div');
      fila.className = 'neon-prod-sel-fila';
      var punto = document.createElement('span');
      punto.className = 'neon-prod-sel-punto';
      if (sw) punto.style.background = sw.style.background;
      var nombre = document.createElement('span');
      nombre.className = 'neon-prod-sel-nombre';
      nombre.textContent = e.valor;
      var paso = document.createElement('div');
      paso.className = 'neon-prod-cantidad neon-prod-sel-paso';
      var menos = document.createElement('button');
      menos.type = 'button'; menos.className = 'neon-prod-cant-btn'; menos.textContent = '–';
      menos.setAttribute('aria-label', 'Restar una unidad de ' + e.valor);
      var num = document.createElement('span');
      num.className = 'neon-prod-sel-num'; num.textContent = e.cant;
      var mas = document.createElement('button');
      mas.type = 'button'; mas.className = 'neon-prod-cant-btn'; mas.textContent = '+';
      mas.setAttribute('aria-label', 'Sumar una unidad de ' + e.valor);
      function cambiar(delta) {
        e.cant = Math.min(99, Math.max(1, e.cant + delta));
        num.textContent = e.cant;
        sincronizarCampos();
      }
      menos.addEventListener('click', function () { cambiar(-1); });
      mas.addEventListener('click', function () { cambiar(1); });
      paso.appendChild(menos); paso.appendChild(num); paso.appendChild(mas);
      fila.appendChild(punto); fila.appendChild(nombre); fila.appendChild(paso);
      seleccionEl.appendChild(fila);
    });
    sincronizarCampos();
    var varios = elegidos.length > 1;
    if (pagoEl) pagoEl.style.display = varios ? 'none' : '';
    if (notaMultiEl) notaMultiEl.hidden = !varios;
    // El botón se bloquea solo si NINGUNO de los colores elegidos tiene stock.
    var alguno = elegidos.some(function (e) { var v = varianteDeColor(e.valor); return v && v.available; });
    if (addBtn) {
      addBtn.disabled = !alguno;
      if (addTexto) addTexto.textContent = alguno ? (addTexto.getAttribute('data-disponible') || addTexto.textContent) : (textoAgotado || addTexto.textContent);
    }
    if (stickyBtn) stickyBtn.disabled = !alguno;
  }

  function alternarColor(valor) {
    var i = elegidos.findIndex(function (e) { return e.valor === valor; });
    if (i > -1) {
      if (elegidos.length === 1) return; // siempre queda al menos un color
      elegidos.splice(i, 1);
    } else {
      elegidos.push({ valor: valor, cant: 1 });
    }
    mostrarError('');
    marcarSwatches();
    actualizar();
  }

  if (multi) {
    // Miniaturas de la galería: "elegir y ver este color" (sin alternar).
    window.neonElegirColor = function (valor) {
      var i = elegidos.findIndex(function (e) { return e.valor === valor; });
      if (i > -1) elegidos.push(elegidos.splice(i, 1)[0]);
      else elegidos.push({ valor: valor, cant: 1 });
      mostrarError('');
      marcarSwatches();
      actualizar();
    };
  }

  grupos.forEach(function (g) {
    g.querySelectorAll('.neon-prod-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (multi) { alternarColor(btn.getAttribute('data-value')); return; }
        g.querySelectorAll('.neon-prod-swatch').forEach(function (b) { b.classList.remove('neon-activa'); });
        btn.classList.add('neon-activa');
        actualizar();
      });
    });
  });

  form.querySelectorAll('.neon-prod-cantidad > .neon-prod-cant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!cantidadInput) return;
      var val = parseInt(cantidadInput.value, 10) || 1;
      if (btn.getAttribute('data-accion') === 'sumar') val += 1;
      else val = Math.max(1, val - 1);
      cantidadInput.value = val;
    });
  });

  // "Llévate 2 y ahorra": deja el pedido en (al menos) 2 unidades y lanza el
  // botón real de compra — mismo formulario, mismas validaciones. Con varios
  // colores elegidos, si ya suman 2 o más no se toca nada.
  var bundleBtn = document.getElementById('neon-prod-bundle-btn');
  if (bundleBtn && addBtn) {
    bundleBtn.addEventListener('click', function () {
      if (multi) {
        var total = elegidos.reduce(function (a, e) { return a + e.cant; }, 0);
        if (total < 2) { principalMulti().cant += 2 - total; pintarSeleccion(); }
      } else if (cantidadInput) {
        cantidadInput.value = 2;
      }
      addBtn.click();
    });
  }

  // NEON (oct 2026) — envío por AJAX a /cart/add.js con un array "items":
  // permite añadir VARIOS colores (cada uno su propia línea de carrito) en
  // un solo clic, y da feedback inmediato (botón "Añadiendo…" + notificación
  // del carrito) en vez de la recarga completa del formulario nativo, que en
  // conexiones lentas parecía "no hacer nada" y provocaba clics repetidos.
  // El botón de pago exprés (Shop Pay/PayPal) NO pasa por aquí: sigue su
  // propio flujo con la variante principal.
  var enviando = false;

  function emitirLineas(items) {
    try {
      var SE = window.StandardEvents;
      if (!SE || !SE.CartLinesUpdateEvent) return null;
      var d = SE.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new SE.CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }),
        promise: d.promise
      }));
      return d;
    } catch (e) { return null; }
  }

  function resolverLineas(d) {
    if (!d) return;
    try {
      fetch(((window.routes && window.routes.cart_url) || '/cart') + '.json')
        .then(function (r) { return r.json(); })
        .then(function (c) { d.resolve({ cart: window.StandardEvents.CartLinesUpdateEvent.createCartFromAjaxResponse(c) }); })
        .catch(function (e) { d.reject(e); });
    } catch (e) { d.reject(e); }
  }

  function enviar() {
    if (enviando || !addBtn) return;
    mostrarError('');
    var items = [];
    if (multi) {
      var agotados = [];
      elegidos.forEach(function (e) {
        var v = varianteDeColor(e.valor);
        if (v && v.available) items.push({ id: v.id, quantity: e.cant });
        else agotados.push(e.valor);
      });
      if (agotados.length) {
        mostrarError('Sin stock ahora mismo: ' + agotados.join(', ') + '. Quítalo para continuar.');
        return;
      }
    } else {
      items.push({ id: parseInt(idInput.value, 10), quantity: parseInt(cantidadInput ? cantidadInput.value : 1, 10) || 1 });
    }

    var carrito = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var cuerpo = { items: items };
    if (carrito && typeof carrito.getSectionsToRender === 'function') {
      cuerpo.sections = carrito.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      cuerpo.sections_url = window.location.pathname;
      if (typeof carrito.setActiveElement === 'function') carrito.setActiveElement(document.activeElement);
    }

    enviando = true;
    addBtn.setAttribute('aria-disabled', 'true');
    addBtn.classList.add('neon-cargando');
    var textoPrevio = addTexto ? addTexto.textContent : '';
    if (addTexto) addTexto.textContent = 'Añadiendo…';
    var evento = emitirLineas(items);

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          mostrarError(res.description || res.message || 'No se pudo añadir al carrito.');
          if (evento) evento.reject(new Error(res.description || res.message || 'add failed'));
          return;
        }
        resolverLineas(evento);
        var ultimo = res.items && res.items[res.items.length - 1];
        try {
          if (!carrito || !res.sections || !ultimo) throw new Error('sin notificación');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'neon-producto', productVariantId: items[0].id, cartData: res });
          }
          carrito.renderContents({ key: ultimo.key, sections: res.sections });
        } catch (e) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (e) {
        mostrarError('No se pudo conectar con la tienda. Inténtalo de nuevo.');
        if (evento) evento.reject(e);
      })
      .finally(function () {
        enviando = false;
        addBtn.removeAttribute('aria-disabled');
        addBtn.classList.remove('neon-cargando');
        if (addTexto) addTexto.textContent = textoPrevio;
      });
  }

  form.addEventListener('submit', function (e) {
    // Cualquier otro botón del formulario (pago exprés) sigue su flujo propio.
    if (e.submitter && e.submitter !== addBtn) return;
    e.preventDefault();
    enviar();
  });

  if (multi) marcarSwatches();

  actualizar();
}

function initNeonStickyBar() {
  var barra = document.getElementById('neon-prod-sticky');
  var addBtnReal = document.getElementById('neon-prod-add');
  var stickyBtn = document.getElementById('neon-prod-sticky-btn');
  if (!barra || !addBtnReal) return;
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () { addBtnReal.click(); });
  }
  var pendiente = false;
  function comprobar() {
    pendiente = false;
    var rect = addBtnReal.getBoundingClientRect();
    barra.classList.toggle('neon-visible', rect.bottom < 0);
  }
  window.addEventListener('scroll', function () {
    if (pendiente) return;
    pendiente = true;
    setTimeout(comprobar, 50);
  }, { passive: true });
  comprobar();
}

var neonCuentaAtrasIntervalo = null;
function initNeonCuentaAtras() {
  // Cuenta atrás real hasta la fecha límite de PEDIDO calculada en
  // neon-urgencia.liquid (31 de octubre menos los días de envío reales).
  // Formato días/horas/minutos — a esta distancia los segundos no aportan
  // nada, solo generan ruido visual.
  var cajas = document.querySelectorAll('[data-neon-cuenta-atras]');
  if (!cajas.length) return;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function poner(caja, n, valorId, etiquetaId, etiqueta) {
    var vEl = caja.querySelector('[data-neon-' + valorId + ']');
    var lEl = caja.querySelector('[data-neon-' + etiquetaId + ']');
    if (vEl) vEl.textContent = pad(n);
    if (lEl) lEl.textContent = etiqueta;
  }
  function actualizar() {
    var ahora = Date.now();
    cajas.forEach(function (caja) {
      var limite = caja.getAttribute('data-neon-limite');
      var fin = new Date(limite);
      if (isNaN(fin.getTime())) { caja.style.display = 'none'; return; }
      var restante = Math.max(0, fin.getTime() - ahora);
      var dias = Math.floor(restante / 86400000);
      var horas = Math.floor((restante % 86400000) / 3600000);
      var minutos = Math.floor((restante % 3600000) / 60000);
      poner(caja, dias, 'v1', 'l1', 'd');
      poner(caja, horas, 'v2', 'l2', 'h');
      poner(caja, minutos, 'v3', 'l3', 'm');
    });
  }
  actualizar();
  if (neonCuentaAtrasIntervalo) clearInterval(neonCuentaAtrasIntervalo);
  neonCuentaAtrasIntervalo = setInterval(actualizar, 60000);
}
